<template>
  <div class="navigation">

    <router-link
      v-for="item in navigationItems"
      :key="item.name"
      :to="{ name: item.name }"
      class="navigation-item"
    >
      <component
        :is="`${item.name}-icon`"
        class="icon"
        :fill="$route.path.match(new RegExp(`/^\/${item.name}/`)) ? '#fff' : '#94979B'"
      />
      <span>{{ item.label }}</span>
    </router-link>
  </div>
</template>

<script>
import DealersIcon from '@/components/icons/DealersIcon.vue';
import AccessoriesIcon from '@/components/icons/AccessoriesIcon.vue';
import InspectionsIcon from '@/components/icons/InspectionsIcon.vue';
import AssistantsIcon from '@/components/icons/AssistantsIcon.vue';
import IndicatorsIcon from '@/components/icons/IndicatorsIcon.vue';
import ModelsIcon from '@/components/icons/ModelsIcon.vue';
import BannerIcon from '@/components/icons/BannerIcon.vue';
import RssIcon from '@/components/icons/RssIcon.vue';
import PlusIcon from '@/components/icons/PlusIcon';

export default {
  name: 'navigation',

  components: {
    DealersIcon,
    AccessoriesIcon,
    InspectionsIcon,
    AssistantsIcon,
    IndicatorsIcon,
    ModelsIcon,
    BannerIcon,
    RssIcon,
    PlusIcon,
  },

  data() {
    return {
      navigationItems: [
        {
          name: 'dealers',
          label: 'Дилеры',
        },
        {
          name: 'accessories',
          label: 'Аксессуары',
        },
        {
          name: 'inspections',
          label: 'Запись на ТО',
        },
        {
          name: 'assistants',
          label: 'Ассистенты',
        },
        {
          name: 'indicators',
          label: 'Индикаторы',
        },
        {
          name: 'models',
          label: 'Модели',
        },
        {
          name: 'banner',
          label: 'Баннер',
        },
        {
          name: 'rss',
          label: 'Новости',
        },
        {
          name: 'plus',
          label: 'Промокоды Я+',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.navigation {
  padding: 20px 30px;

  .navigation-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 10px 0;
    cursor: pointer;
    text-decoration: none;
    color: var(--aluminnium-color);

    &.router-link-active {
      color: var(--white-color);
    }

    .icon {
      width: 18px;
      height: 18px;
    }

    span {
      margin-left: 10px;
    }
  }
}
</style>
